import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{if
    this.post
    (i18n "post.share.title" post_number=this.post.post_number)
    (i18n "topic.share.title")
  }}
  @subtitle={{if this.post this.displayDate}}
  @closeModal={{@closeModal}}
  @flash={{this.flash}}
  @flashType={{this.flashType}}
  class="share-topic-modal"
>
  <form>
    <div class="input-group invite-link">
      <label for="invite-link">
        {{if
          this.post
          (i18n "post.share.instructions" post_number=this.post.post_number)
          (i18n "topic.share.instructions")
        }}
      </label>
      <div class="link-share-container">
        <Input
          id="invite-link"
          name="invite-link"
          class="invite-link"
          @value={{this.url}}
          readonly={{true}}
          size="200"
        />
        <CopyButton @selector="input.invite-link" @ariaLabel="share.url" />
      </div>
    </div>

    <div class="link-share-actions">
      <div class="sources">
        {{#each this.sources as |source|}}
          <ShareSource @source={{source}} @action={{this.share}} />
        {{/each}}

        {{#if this.allowInvites}}
          <DButton
            @label="topic.share.invite_users"
            @icon="user-plus"
            @action={{this.inviteUsers}}
            class="btn-default invite"
          />
        {{/if}}

        {{#if this.topic.details.can_reply_as_new_topic}}
          {{#if this.topic.isPrivateMessage}}
            <DButton
              @action={{this.replyAsNewTopic}}
              @icon="plus"
              @ariaLabel="post.reply_as_new_private_message"
              @title="post.reply_as_new_private_message"
              @label="user.new_private_message"
              class="btn-default new-topic"
            />
          {{else}}
            <DButton
              @action={{this.replyAsNewTopic}}
              @icon="plus"
              @ariaLabel="post.reply_as_new_topic"
              @title="post.reply_as_new_topic"
              @label="topic.create"
              class="btn-default new-topic"
            />
          {{/if}}
        {{/if}}
        <PluginOutlet
          @name="share-topic-sources"
          @outletArgs={{hash topic=this.topic post=this.post}}
        />
      </div>
    </div>
  </form>
</DModal>
*/
{
  "id": "19l2afYG",
  "block": "[[[8,[39,0],[[24,0,\"share-topic-modal\"]],[[\"@title\",\"@subtitle\",\"@closeModal\",\"@flash\",\"@flashType\"],[[52,[30,0,[\"post\"]],[28,[37,2],[\"post.share.title\"],[[\"post_number\"],[[30,0,[\"post\",\"post_number\"]]]]],[28,[37,2],[\"topic.share.title\"],null]],[52,[30,0,[\"post\"]],[30,0,[\"displayDate\"]]],[30,1],[30,0,[\"flash\"]],[30,0,[\"flashType\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[10,\"form\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"input-group invite-link\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,\"for\",\"invite-link\"],[12],[1,\"\\n        \"],[1,[52,[30,0,[\"post\"]],[28,[37,2],[\"post.share.instructions\"],[[\"post_number\"],[[30,0,[\"post\",\"post_number\"]]]]],[28,[37,2],[\"topic.share.instructions\"],null]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"link-share-container\"],[12],[1,\"\\n        \"],[8,[39,3],[[24,1,\"invite-link\"],[24,3,\"invite-link\"],[24,0,\"invite-link\"],[16,\"readonly\",true],[24,\"size\",\"200\"]],[[\"@value\"],[[30,0,[\"url\"]]]],null],[1,\"\\n        \"],[8,[39,4],null,[[\"@selector\",\"@ariaLabel\"],[\"input.invite-link\",\"share.url\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"link-share-actions\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"sources\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"sources\"]]],null]],null],null,[[[1,\"          \"],[8,[39,7],null,[[\"@source\",\"@action\"],[[30,2],[30,0,[\"share\"]]]],null],[1,\"\\n\"]],[2]],null],[1,\"\\n\"],[41,[30,0,[\"allowInvites\"]],[[[1,\"          \"],[8,[39,8],[[24,0,\"btn-default invite\"]],[[\"@label\",\"@icon\",\"@action\"],[\"topic.share.invite_users\",\"user-plus\",[30,0,[\"inviteUsers\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"topic\",\"details\",\"can_reply_as_new_topic\"]],[[[41,[30,0,[\"topic\",\"isPrivateMessage\"]],[[[1,\"            \"],[8,[39,8],[[24,0,\"btn-default new-topic\"]],[[\"@action\",\"@icon\",\"@ariaLabel\",\"@title\",\"@label\"],[[30,0,[\"replyAsNewTopic\"]],\"plus\",\"post.reply_as_new_private_message\",\"post.reply_as_new_private_message\",\"user.new_private_message\"]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,8],[[24,0,\"btn-default new-topic\"]],[[\"@action\",\"@icon\",\"@ariaLabel\",\"@title\",\"@label\"],[[30,0,[\"replyAsNewTopic\"]],\"plus\",\"post.reply_as_new_topic\",\"post.reply_as_new_topic\",\"topic.create\"]],null],[1,\"\\n\"]],[]]]],[]],null],[1,\"        \"],[8,[39,9],null,[[\"@name\",\"@outletArgs\"],[\"share-topic-sources\",[28,[37,10],null,[[\"topic\",\"post\"],[[30,0,[\"topic\"]],[30,0,[\"post\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@closeModal\",\"source\"],false,[\"d-modal\",\"if\",\"i18n\",\"input\",\"copy-button\",\"each\",\"-track-array\",\"share-source\",\"d-button\",\"plugin-outlet\",\"hash\"]]",
  "moduleName": "discourse/components/modal/share-topic.hbs",
  "isStrictMode": false
});